import React from "react";
import { Transition } from "@headlessui/react";
import Login from "../../Pages/Login/index";
import SignUp from "../../Pages/SignUp";
import ForgotPassword from "../../Pages/ForgotPassword";
import Review from "../../Pages/Review/Review";
import Confirm from "../../Pages/Confirm/Confirm";
import Transitions from "../../Pages/Transition/Transition";
import Detail from "../../Pages/ViewDetail/detail";

function NavBar({ setShowModal, showModal }) {
  const [isOpen, setIsOpen] = React.useState(false);
  // const [toggle, setToggle] = React.useState(true);
  // const toggleClass = " transform translate-x-5";

  return (
    <div>
      <nav className="bg-primary">
        <div className=" mx-auto px-4 sm:px-6 lg:px-20">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center">
                <div className=" mr-2 flex md:hidden">
                  <button
                    onClick={() => setIsOpen(!isOpen)}
                    type="button"
                    className=" inline-flex items-center justify-center p-2 rounded-md text-gray-100 hover:text-white  "
                    aria-controls="mobile-menu"
                    aria-expanded="false"
                  >
                    <span className="sr-only">Open main menu</span>
                    {!isOpen ? (
                      <svg
                        className="block h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 6h16M4 12h16M4 18h16"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="block h-6 w-6"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                <div className="font-bold text-white text-lg">
                  Logo<span className="font-light">here.</span>
                </div>
              </div>
              <div className="hidden lg:block   ">
                <div className="ml-5 flex items-baseline space-x-4">
                  <a
                    href="/"
                    className="  text-white px-3 py-2 rounded-md text-sm font-medium"
                  >
                    Home
                  </a>

                  <a
                    href="/"
                    className="text-gray-100  hover:text-white px-3 py-2 rounded-md text-sm font-light"
                  >
                    Find media rates
                  </a>

                  <a
                    href="/"
                    className="text-gray-100  hover:text-white px-3 py-2 rounded-md text-sm font-light"
                  >
                    Categories
                  </a>

                  <a
                    href="/"
                    className="text-gray-100  hover:text-white px-3 py-2 rounded-md text-sm font-light"
                  >
                    About us
                  </a>

                  <a
                    href="/"
                    className="text-gray-100  hover:text-white px-3 py-2 rounded-md text-sm font-light"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
              <div className="">
                <button className="px-10 bg-white rounded-full py-2" onClick={() => setShowModal(1)}>
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </div>

        <Transition
          show={isOpen}
          enter="transition ease-out duration-100 transform"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="transition ease-in duration-75 transform"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
          {(ref) => (
            <div className="md:hidden" id="mobile-menu">
              <div ref={ref} className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                <a href="/" className=" text-white block px-3 py-2 rounded-md text-base font-medium">Home</a>
                <a href="/" className="text-gray-300  hover:text-white block px-3 py-2 rounded-md text-base font-medium">Find Media Rates</a>
                <a href="/" className="text-gray-300  hover:text-white block px-3 py-2 rounded-md text-base font-medium">Categories</a>
                <a href="/" className="text-gray-300  hover:text-white block px-3 py-2 rounded-md text-base font-medium">About Us</a>
                <a href="/" className="text-gray-300  hover:text-white block px-3 py-2 rounded-md text-base font-medium">Contact Us</a>
              </div>
            </div>
          )}
        </Transition>
      </nav>
      {showModal === 1 ? <Login setShowModal={setShowModal} showModal={showModal} />
        : null}

    {showModal === 2 ? <SignUp setShowModal={setShowModal} showModal={showModal} />
        : null}
    {showModal === 3 ? <ForgotPassword setShowModal={setShowModal} showModal={showModal} />
    : null}

    {showModal === 5 ? <Review setShowModal={setShowModal} showModal={showModal} />
    : null}

    {showModal === 6 ? <Confirm setShowModal={setShowModal} showModal={showModal} />
    : null}


    {showModal === 7 ? <Transitions setShowModal={setShowModal} showModal={showModal} />
            : null}

  {showModal === 8 ? <Detail setShowModal={setShowModal} showModal={showModal} />
              : null}

    </div>

  );
}

export default NavBar;
